// extracted by mini-css-extract-plugin
export default {"container":"_popUpTemplate_container__-zA1K","popup":"_popUpTemplate_popup__vi2R9","close":"_popUpTemplate_close__6DwkV"};